// CHANGE-042: the company's profile: logo, name, website. Reached from the user menu, never from set-up.
import { useEffect, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api, useCurrentCompany, useRefreshMe } from '../../lib'
import { ErrorBox, Loading, NoCompany } from '../../app/ui'
import { LogoEdit } from '../../app/logo'
import { InviteLink } from '../card/CardPages'

type Company = { id: string; name: string; website: string | null; role: 'admin' | 'member'; logo_url: string | null }

export function ProfilePage() {
  const company = useCurrentCompany()
  const refreshMe = useRefreshMe()
  const qc = useQueryClient()
  const key = ['accounts', 'company', company?.id]
  const q = useQuery({ queryKey: key, queryFn: () => api<Company>('GET', `/api/companies/${company!.id}`), enabled: !!company })
  const [f, setF] = useState({ name: '', website: '' })
  useEffect(() => {
    if (q.data) setF({ name: q.data.name, website: q.data.website ?? '' })
  }, [q.data?.id])
  const refresh = () => {
    qc.invalidateQueries({ queryKey: key })
    refreshMe()
  }
  const save = useMutation({
    mutationFn: () => api('PATCH', `/api/companies/${company!.id}`, { name: f.name, website: f.website }),
    onSuccess: refresh,
  })
  if (!company) return <NoCompany />
  if (!q.data) return q.error ? <ErrorBox error={q.error} /> : <Loading />
  const c = q.data
  const admin = c.role === 'admin'
  return (
    <form className="page narrow stack" data-testid="accounts-profile"
      onSubmit={(e) => { e.preventDefault(); save.mutate() }}>
      <h1>Profile</h1>
      <LogoEdit name={c.name} url={c.logo_url} path={`/api/companies/${c.id}/logo`} canEdit={admin} onChange={refresh}
        testid="accounts-logo" />
      <label>
        Company name
        <input data-testid="accounts-profile-name" value={f.name} disabled={!admin} required
          onChange={(e) => setF({ ...f, name: e.target.value })} />
      </label>
      <label>
        Website
        <input data-testid="accounts-profile-website" value={f.website} disabled={!admin} placeholder="https://example.com"
          onChange={(e) => setF({ ...f, website: e.target.value })} />
      </label>
      {!!save.error && <ErrorBox error={save.error} />}
      {admin && (
        <div className="row">
          <button className="primary" data-testid="accounts-profile-save" disabled={save.isPending}>Save</button>
          {save.isSuccess && <span className="muted" data-testid="accounts-profile-saved">Saved.</span>}
        </div>
      )}
      <InviteLink />
    </form>
  )
}
